export default class SwipeController {
    constructor(element) {
        this.xDown = null;
        this.yDown = null;
        this.element = element;

        this.element.addEventListener(
            'touchstart',
            (evt) => {
                this.xDown = evt.touches[0].clientX;
                this.yDown = evt.touches[0].clientY;
            },
            false
        );

        this.element.addEventListener(
            'touchend',
            () => {
                this.xDown = null;
                this.yDown = null;
            },
            false
        );

        this.element.addEventListener(
            'mousedown',
            (evt) => {
                this.xDown = evt.clientX;
                this.yDown = evt.clientY;
            },
            false
        );

        this.element.addEventListener(
            'mouseup',
            () => {
                this.xDown = null;
                this.yDown = null;
            },
            false
        );
    }

    onLeft(callback) {
        this.onLeft = callback;

        return this;
    }

    onRight(callback) {
        this.onRight = callback;

        return this;
    }

    onUp(callback) {
        this.onUp = callback;

        return this;
    }

    onDown(callback) {
        this.onDown = callback;

        return this;
    }

    handleTouchMove(x, y) {
        if (!this.xDown || !this.yDown) {
            return;
        }

        const xUp = x;
        const yUp = y;

        this.xDiff = this.xDown - xUp;
        this.yDiff = this.yDown - yUp;

        if (Math.abs(this.xDiff) > Math.abs(this.yDiff)) {
            // Most significant.
            if (this.xDiff > 0) {
                this.onLeft();
            } else {
                this.onRight();
            }
        } else if (this.yDiff > 0) {
            this.onUp();
        } else {
            this.onDown();
        }

        // Reset values.
        // this.xDown = null;
        // this.yDown = null;
    }

    run() {
        this.element.addEventListener(
            'touchmove',
            (evt) => {
                this.handleTouchMove(evt.touches[0].clientX, evt.touches[0].clientY);
            },
            false
        );

        this.element.addEventListener(
            'mousemove',
            (evt) => {
                this.handleTouchMove(evt.clientX, evt.clientY);
            },
            false
        );
    }
}
